export function traversalRoutes(routes, opts) {
    const routesMap = {};
    function traversal(subRoutes, parentPath) {
        for (let i = 0; i < subRoutes.length; i++) {
            const route = subRoutes[i];
            if (route) {
                const routePath = `${opts?.containParentPath ? `${parentPath}/` : ''}${route?.path || ''}`.replace(/\/{2,}/g, '/');
                routesMap[routePath] = {
                    ...route,
                    label: opts?.labelIndex ? route[opts.labelIndex] : route.label,
                };
                if (route.children?.length) {
                    traversal(route.children, routePath ?? parentPath);
                }
            }
        }
    }
    traversal(routes, '/');
    return routesMap;
}
export function matchRoute(path, routes) {
    for (const routePath in routes) {
        const regex = new RegExp('^' + routePath.replace(/:[a-zA-Z0-9]+/g, '([a-zA-Z0-9]+)') + '$');
        const match = path.match(regex);
        if (match) {
            return routes[routePath];
        }
    }
}
export function generateBreadcrumbs(path, routes) {
    const pathSegments = path.split('/').filter((segment) => segment !== ''); // 过滤掉空的路径段
    let currentPath = '';
    const breadcrumbs = [];
    for (const segment of pathSegments) {
        currentPath += `/${segment}`;
        const currentRoute = routes[currentPath];
        if (currentRoute?.label) {
            breadcrumbs.push({
                ...currentRoute,
                path: currentPath,
                content: currentRoute.label,
                currentPath,
            });
        }
        else {
            const dynamicRoutePath = Object.keys(routes).find((route) => {
                const regex = new RegExp('^' + route.replace(/:[a-zA-Z0-9]+/g, '([a-zA-Z0-9]+)') + '$');
                return currentPath.match(regex);
            });
            const dynamicRoute = dynamicRoutePath ? routes[dynamicRoutePath] : null;
            if (dynamicRoute) {
                breadcrumbs.push({
                    ...dynamicRoute,
                    path: dynamicRoutePath,
                    content: dynamicRoute.label,
                    currentPath,
                });
            }
        }
    }
    return breadcrumbs;
}
